import { getField, updateField } from "vuex-map-fields";
import router from "../../../router";
let checkingCreateFido = new Object();

const getDefaultState = () => {
  return {
    isRegistBiometry: "0", // 기기에 등록된 지문이 있는지 여부
    checkCreateFidoNative: false,
    router: "",
    route: "",
    isFidoActionSheetOpen: false, // app.vue fido action-sheet
    isFidoActionSheetError: false, // app.vue fido action-sheet error
    fidoActionSheetTitle: "", // app.vue fido action-sheet title
    fidoActionSheetContent: "", // app.vue fido action-sheet content
    isFidoPopOpen: false, // app.vue fido 팝업
    fidoPopTitle: "", // app.vue fido 팝업 타이틀
    fidoPopMessage: "", // app.vue fido 팝업 메시지
    fidoPopConfirm: "",
    isPincode: "0",
    isFingerprint: "0",
    /**
     * 서버의 fido 정보를 가져옴 - 로그인
     */
    svrFidoInfo: {
      in: {},
      out: {
        success: {
          fidoid: "", // fidoid
          systemId: "", // systemid
          fidoInfo: {
            operGroupCd: "",
            fIDOID: "",
            coprPpsnDstcd: "",
            cin: "",
            wWWBnkgLginID: "",
            pinRegiYMS: "",
            pinFailNotms: "",
            pinStusDstcd: "",
            pinStusModfiYMS: "",
            fngprRegiDstcd: "",
            fngprStusLastModfiYMS: "",
            smphMchtlUniqNo: "",
            smphMchtlDstcd: "",
            pgmVsnno: "",
            smphMdelName: "",
            writYMS: "",
            lastAmndYMS: "",
            rmark: "",
            fidoid: "",
            wwwbnkgLginID: "",
            fngprUseYn: "",
          }, // fido등록정보
          isSimple: false, // 간편인증사용여부
        },
        fail: {},
      },
    },
    /**
     * 간편비밀번호 보안유효성 검사
     */
    checkMpin: {
      in: {
        mPin01: "",
        mPin02: "",
      },
      out: {
        success: {
          rsultCd: "",
          equalResult: "",
        },
        fail: {},
      },
    },
    /**
     * 기기에 등록된 fido 사용자 정보
     */
    fidoRegInfo: {
      in: {},
      out: [
        // {"userName": "mOTP아이디", “isPincode”: “0/1”, “isFingerprint”: “0/1”, "isPattern":"0/1"}
      ],
    },
    /**
     * fido 등록
     */
    fidoReg: {
      /**
       * fido등록 요청
       */
      uafRequest: {
        in: {
          device: "", // 디바이스 ID
          smphMdelName: "", // 디바이스 모델명
          bioType: "", // 인식 TYPE ( FINGERPRINT : fingerprint인식, PINCODE : PIN, PATTERN : 패턴 )
          bizDscd: "", // 업무구분코드
        },
        out: {
          success: {
            bioType: "", // 인식 TYPE ( FINGERPRINT : fingerprint인식, PINCODE : PIN, PATTERN : 패턴 )
            userName: "", // FIDO USERID
            systemId: "", // 시스템 정보
            fidoReqMessage: "", // 등록 요청 FIDO Protocol
          },
          fail: {},
        },
      },
      /**
       * fido등록 app 함수 호출
       */
      appReq: {
        in: {
          // uafRequest.out.success 사용.
        },
        out: {
          result: "", // 결과코드(SUCCESS/ERROR)
          uafResponse: "", // FIDO APP 응답
          errorcode: "", // ERROR코드
        },
      },
      /**
       * fido등록 응답
       */
      uafResponse: {
        in: {
          uafResponse: "", // FIDO APP 응답
          smphMchtlUniqNo: "", // 스마트폰 기기고유번호
          smphMchtlDstcd: "", // 스마트폰기기 구분코드
          pgmVsnno: "", // 프로그램버전번호
          smphMdelName: "", // 스마트폰모델명
          bioType: "", // 인식 TYPE ( FINGERPRINT : fingerprint인식, PINCODE : PIN, PATTERN : 패턴 )
        },
        out: {
          success: {
            statusCode: "", // 상태코드
            Description: "", // 에러코드 설명
            USERNAME: "", // FIDO USERID
          },
          fail: {},
        },
      },
    },
    /**
     * fido 인증
     */
    fidoCertn: {
      /**
       * fido인증 요청
       */
      uafRequest: {
        in: {
          device: "", // 디바이스 ID
          smphMdelName: "", // 디바이스 모델명
          bioType: "", // 인식 TYPE ( FINGERPRINT : fingerprint인식, PINCODE : PIN, PATTERN : 패턴 )
          fidoid: "", // fidoid
          bizDscd: "", // 업무구분
        },
        out: {
          success: {
            bioType: "", // 인식 TYPE ( FINGERPRINT : fingerprint인식, PINCODE : PIN, PATTERN : 패턴 )
            userName: "", // FIDO USERID
            systemId: "", // 시스템 정보
            fidoReqMessage: "", // 등록 요청 FIDO Protocol
          },
          fail: {},
        },
      },
      /**
       * fido인증 app 함수 호출
       */
      appReq: {
        in: {
          // uafRequest.out.success 사용.
          userName: "", // pin 5회 실패시, 상태 업데이트시 사용함.
        },
        out: {
          result: "", // 결과코드(SUCCESS/ERROR)
          uafResponse: "", // FIDO APP 응답
          errorcode: "", // ERROR코드
          failcount: 0, // 간편인증번호 오류횟수
        },
      },
      /**
       * fido인증 응답 + 로그인
       */
      uafResponse: {
        in: {
          fidoid: "", // FIDOID
          uafResponse: "", // FIDO APP 응답
          smphMchtlUniqNo: "", // 스마트폰기기고유번호
          appTokenCtnt: "", // 앱토큰내용
          pshtCtnt: "", // 푸쉬토큰내용
          appVsnnoName: "", // 앱버전번호명
          oSzInfoCtnt: "", // OS정보내용
          smphMchtlDstcd: "", // 스마트폰기기구분코드
        },
        out: {
          success: {
            statusCode: "", // 상태코드
            Description: "", // 에러코드 설명
            USERNAME: "", // FIDO USERID
          },
          fail: {},
        },
      },
    },
    /**
     * fido 간편인증번호 5회 실패
     */
    updatePincodeErr: {
      in: {
        fidoid: "",
      },
      out: {
        success: {},
        fail: {},
      },
    },
    /**
     * mOTP 정보 - 유효성 check 용도
     */
    checkMotp: {
      in: {},
      out: {
        success: {
          mOtpInfo: {
            operGroupCd: "", // 운영그룹코드
            iD: "", // mOTP ID
            otpStusDstcd: "", // OTP상태구분코드
            coprPpsnDstcd: "", // 법인개인구분코드
            cin: "", // 고객정보번호
            wWWBnkgLginID: "", // 인터넷뱅킹로그인ID
            mchtlUniqNo: "", // 기기고유번호
            pinFailNotms: 0, // 핀실패횟수
            certnErrNotms: 0, // 인증오류횟수
            smphMchtlUniqNo: "", // 스마트폰기기고유번호
            smphMchtlDstcd: "", // 스마트폰기기구분코드(1:IPhone, 2:안드로이드)
            pgmVsnno: "", // 프로그램버전번호
            certnDmndCd: "", // 인증요청코드(1:자동, 2:수동)
            smphMdelName: "", // 스마트폰모델명
          },
        },
      },
    },
  };
};

const createFido = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
    getFidoReg: state => {
      return state.fidoReg;
    },
    getFidoCertn: state => {
      return state.fidoCertn;
    },
    getCheckMpin: state => {
      return state.checkMpin;
    },
    getFidoRegInfo: state => {
      return state.fidoRegInfo;
    },
    getSvrFidoInfo: state => {
      return state.svrFidoInfo;
    },
    getStateAll: state => {
      return state;
    },
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
    /**
     * 간편비밀번호 보안유효성 검사 데이터를 업데이트 함.
     */
    mut001_createFido: function(state, payload) {
      this._vm.$set(state.checkMpin.in, payload.key, payload.value);
    },
    /**
     * 간편인증번호 데이터를 초기화 함.
     * @param {*} state
     * @param {*} payload
     */
    mut002_createFido: state => {
      Object.assign(state.checkMpin, getDefaultState().checkMpin);
    },
    /**
     * fido등록 appReq 응답데이터를 업데이트 함.
     * @param {*} state
     * @param {*} payload
     */
    mut003_createFido: function(state, payload) {
      this._vm.$set(state.fidoReg.appReq.out, payload.key, payload.value);
    },
    /**
     * 기기에 등록된 fido 사용자 정보 결과를 업데이트 함.
     */
    mut004_createFido: function(state, payload) {
      state.fidoRegInfo.out = [];
      payload.Fidoinfo.length > 0 &&
        payload.Fidoinfo.forEach(e => {
          state.fidoRegInfo.out.push(e);
        });
    },
    /**
     * fido인증 appReq 응답데이터를 업데이트 함.
     * @param {*} state
     * @param {*} payload
     */
    mut005_createFido: function(state, payload) {
      this._vm.$set(state.fidoCertn.appReq.out, payload.key, payload.value);
    },
  },
  actions: {
    /**
     * 간편인증번호의 보안유효성 && 동일성 검사
     * @param {*} context
     * @param {*} payload
     */
    act001_createFido: function(context) {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/fido/fidoIssunc/checkMpin",
          context.state.checkMpin.in,
          response => {
            // 첫번째 입력. 성공.
            if (context.state.checkMpin.in.mPin01 !== "" && context.state.checkMpin.in.mPin02 === "") {
              // [native] keypad 2번째 입력한다.
              context.dispatch("act002_createFido", "openKeypadForFidoReg2");
            }

            // 두번째 입력. 성공.
            if (context.state.checkMpin.in.mPin01 !== "" && context.state.checkMpin.in.mPin02 !== "") {
              if (context.state.fidoCertn.uafRequest.in.bizDscd === "changePincode") {
                // pincode 단순변경
                const param = {
                  device: this.state.native.smphMchtlUniqNo,
                  smphMdelName: this.state.native.smphMdelName,
                  bioType: "PINCODE",
                  bizDscd: "changePincode",
                };
                // act004_createFido -> this._vm.$bridge.fidoReg -> act005_createFido
                this.dispatch("auth/createFido/act004_createFido", param); // fido 등록요청
              } else {
                router.push({ name: "createFidoPincodeStep2" }); // 다음 화면으로..
              }
            }

            this._vm.$set(context.state.checkMpin.out, "success", response);
            resolve("success");
          },
          response => {
            // 첫번째 입력. 실패
            if (context.state.checkMpin.in.mPin01 !== "" && context.state.checkMpin.in.mPin02 === "") {
              context.commit("mut001_createFido", { key: "mPin01", value: "" });
            }

            // 두번째 입력. 실패
            if (context.state.checkMpin.in.mPin01 !== "" && context.state.checkMpin.in.mPin02 !== "") {
              context.commit("mut001_createFido", { key: "mPin02", value: "" });
            }

            this._vm.$set(context.state.checkMpin.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * native bridge call
     */
    act002_createFido: function(context, payload) {
      switch (payload) {
        case "openKeypadForFidoReg1":
          this._vm.$bridge.openKeypadForFidoReg1();
          break;
        case "openKeypadForFidoReg2":
          this._vm.$bridge.openKeypadForFidoReg2();
          break;
        case "fidoReg":
          if (context.state.fidoReg.uafRequest.out.success.bioType === "FINGERPRINT") {
            this.state.auth.createFido.fidoActionSheetTitle = this.state.native.biometryTypeIos === "faceId" ? "MLGI-06-02-02-01" : "MLGI-06-02-01-01";
            this.state.auth.createFido.fidoActionSheetContent = this.state.native.biometryTypeIos === "faceId" ? "MLGI-06-02-02-02" : "MLGI-06-02-01-02";
            this.state.auth.createFido.isFidoActionSheetError = false;
            this.state.auth.createFido.isFidoActionSheetOpen = true;
          }

          this._vm.$bridge.fidoReg(context.state.fidoReg.uafRequest.out.success);
          break;
        case "setFidoReg":
          this._vm.$bridge.setFidoReg({
            userName: context.state.fidoReg.uafRequest.out.success.userName,
            bioType: context.state.fidoReg.uafRequest.in.bioType,
          });
          break;
        case "setSimpleLogin":
          this._vm.$bridge.setSimpleLogin({
            userName: context.state.fidoReg.uafRequest.out.success.userName,
            bioType: context.state.fidoReg.uafRequest.in.bioType,
            siteCode: this.state.siteCode,
          });
          break;
        case "fidoCertn": // fido 인증 - 간편로그인(commonbiz)
          if (context.state.fidoCertn.uafRequest.out.success.bioType === "FINGERPRINT") {
            this.state.auth.createFido.fidoActionSheetTitle = this.state.native.biometryTypeIos === "faceId" ? "MLGI-06-01-04-01" : "MLGI-06-01-03-01";
            this.state.auth.createFido.fidoActionSheetContent = this.state.native.biometryTypeIos === "faceId" ? "MLGI-06-01-04-02" : "MLGI-06-01-03-02";
            this.state.auth.createFido.isFidoActionSheetError = false;
            this.state.auth.createFido.isFidoActionSheetOpen = true;
          }

          this._vm.$bridge.fidoCertn(context.state.fidoCertn.uafRequest.out.success);
          break;
        case "fidoCertn_general": // fido 인증 - 일반인증
          if (context.state.fidoCertn.uafRequest.out.success.bioType === "FINGERPRINT") {
            this.state.auth.createFido.fidoActionSheetTitle = this.state.native.biometryTypeIos === "faceId" ? "MLGI-06-01-04-01" : "MLGI-06-01-03-01";
            this.state.auth.createFido.fidoActionSheetContent = this.state.native.biometryTypeIos === "faceId" ? "MLGI-06-01-04-02" : "MLGI-06-01-03-02";
            this.state.auth.createFido.isFidoActionSheetError = false;
            this.state.auth.createFido.isFidoActionSheetOpen = true;
          }

          this._vm.$bridge.fidoCertn_general(context.state.fidoCertn.uafRequest.out.success);
          break;
        case "fidoReg_simpleLogin": // fido 등록 시 간편로그인(commonbiz)
          if (context.state.fidoCertn.uafRequest.out.success.bioType === "FINGERPRINT") {
            this.state.auth.createFido.fidoActionSheetTitle = this.state.native.biometryTypeIos === "faceId" ? "MLGI-06-01-04-01" : "MLGI-06-01-03-01";
            this.state.auth.createFido.fidoActionSheetContent = this.state.native.biometryTypeIos === "faceId" ? "MLGI-06-01-04-02" : "MLGI-06-01-03-02";
            this.state.auth.createFido.isFidoActionSheetError = false;
            this.state.auth.createFido.isFidoActionSheetOpen = true;
          }

          this._vm.$bridge.fidoReg_simpleLogin(context.state.fidoCertn.uafRequest.out.success);
          break;
        case "fidoReg_fidoReq": // 간편로그인 후 fido 등록 - 간편로그인(commonbiz)
          if (context.state.fidoReg.uafRequest.out.success.bioType === "FINGERPRINT") {
            this.state.auth.createFido.fidoActionSheetTitle = this.state.native.biometryTypeIos === "faceId" ? "MLGI-06-02-02-01" : "MLGI-06-02-01-01";
            this.state.auth.createFido.fidoActionSheetContent = this.state.native.biometryTypeIos === "faceId" ? "MLGI-06-02-02-02" : "MLGI-06-02-01-02";
            this.state.auth.createFido.isFidoActionSheetError = false;
            this.state.auth.createFido.isFidoActionSheetOpen = true;
          }

          this._vm.$bridge.fidoReg_fidoReq(context.state.fidoReg.uafRequest.out.success);
          break;
      }
    },
    /**
     * 간편인증번호 등록시 2번째 키패드 이전버튼 클릭시.. 일단 간편인증번호 등록 처음부터..
     */
    act003_createFido: function(context) {
      context.commit("mut001_createFido", { key: "mPin01", value: "" });
      context.commit("mut001_createFido", { key: "mPin02", value: "" });
    },
    /**
     * FIDO 등록요청
     * @param {*} context
     */
    act004_createFido: function(context, payload) {
      Object.assign(context.state.fidoReg, getDefaultState().fidoReg);
      context.state.fidoReg.uafRequest.in = payload;

      return new Promise(resolve => {
        this._vm.$post(
          "/auth/fido/fidoIssunc/uafRegRequest",
          context.state.fidoReg.uafRequest.in,
          response => {
            this._vm.$set(context.state.fidoReg.uafRequest.out, "success", response);
            context.dispatch("act002_createFido", "fidoReg");
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.fidoReg.uafRequest.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * FIDO 등록응답 ... fido 등록 완료 시점.
     * @param {*} context
     */
    act005_createFido: function(context) {
      return new Promise(resolve => {
        context.state.fidoReg.uafResponse.in.uafResponse = context.state.fidoReg.appReq.out.uafResponse;
        context.state.fidoReg.uafResponse.in.smphMchtlUniqNo = this.state.native.smphMchtlUniqNo;
        context.state.fidoReg.uafResponse.in.smphMchtlDstcd = this.state.native.smphMchtlDstcd;
        context.state.fidoReg.uafResponse.in.pgmVsnno = this.state.native.pgmVsnno;
        context.state.fidoReg.uafResponse.in.smphMdelName = this.state.native.smphMdelName;
        context.state.fidoReg.uafResponse.in.bioType = context.state.fidoReg.uafRequest.in.bioType;

        this._vm.$post(
          "/auth/fido/fidoIssunc/uafRegResponse",
          context.state.fidoReg.uafResponse.in,
          response => {
            this._vm.$set(context.state.fidoReg.uafResponse.out, "success", response);
            resolve("success");
            // fido 등록정보 기기에 저장
            context.dispatch("act002_createFido", "setFidoReg");

            // 간편로그인 정보 기기에 저장
            context.dispatch("act002_createFido", "setSimpleLogin");

            /*  
              MLGI-05-02-04-01: 간편 인증 번호 등록
              MLGI-05-02-04-02: 간편 인증 번호가 등록되었습니다.
              MLGI-05-02-04-03: 보안을 위해서 변경하신 인증 번호는 반드시 기억해 주시기 바랍니다.
            */
            if (context.state.fidoReg.uafRequest.in.bioType === "PINCODE") {
              context.state.isFidoPopOpen = true;
              if (context.state.fidoReg.uafRequest.in.bizDscd === "changePincode") {
                context.state.fidoPopTitle = "MLGI-05-02-04-05";
              } else {
                context.state.fidoPopTitle = "MLGI-05-02-04-01";
              }

              // context.state.fidoPopMessage = "MLGI-05-02-04-01" + "<br/>" + "MLGI-05-02-04-03";
              context.state.fidoPopMessage = "MLGI-05-02-04-03";
              context.state.fidoPopConfirm = () => {
                context.state.isFidoPopOpen = false;

                if ("1|2".includes(this.state.sessionInfo.userInfo.userPwdRegiYn)) {
                  router.push({ name: "changePasswordOnceStep3" }); // 최초 가입인 경우
                } else {
                  this.state.simpleLogin.siteCodeForSimpleLogin = ""; // main화면 mounted, updated 실행
                  router.push({ name: "main", params: { siteCode: context.rootState.siteCode, lang: context.rootState.lang } }); // 메인화면으로..
                }
              };
            } else if (context.state.fidoReg.uafRequest.in.bioType === "FINGERPRINT") {
              context.state.isFidoPopOpen = true;

              //context.state.fidoPopTitle = context.rootGetters["native/getFingerText"] + " 인증 등록";
              //context.state.fidoPopMessage = context.rootGetters["native/getFingerText"] + " 인증이 등록되었습니다.";
              /*
              MLGI-06-02-03-01: 지문 인증 등록
              MLGI-06-02-03-04: Face ID 인증 등록
              MLGI-06-02-03-02: 지문 인증이 등록되었습니다.
              MLGI-06-02-03-05: Face ID 인증이 등록되었습니다.
              */
              context.state.fidoPopTitle = context.rootGetters["native/getFingerText"] === "FaceID" ? "MLGI-06-02-03-04" : "MLGI-06-02-03-01";
              context.state.fidoPopMessage = context.rootGetters["native/getFingerText"] === "FaceID" ? "MLGI-06-02-03-05" : "MLGI-06-02-03-02";

              context.state.fidoPopConfirm = () => {
                context.state.isFidoPopOpen = false;
                this.state.simpleLogin.siteCodeForSimpleLogin = ""; // main화면 mounted, updated 실행
                router.push({ name: "main", params: { siteCode: context.rootState.siteCode, lang: context.rootState.lang }}); // 메인화면으로..
              };
            }
          },
          response => {
            this._vm.$set(context.state.fidoReg.uafResponse.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * FIDO 등록정보를 가져옴.
     */
    act006_createFido: function(context) {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/fido/fidoIssuncPincode/getFidoInfo",
          context.state.svrFidoInfo.in,
          response => {
            this._vm.$set(context.state.svrFidoInfo.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.svrFidoInfo.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /*
     * 간편로그인 인증요청 - commonbiz에서 처리함(로그인 후 처리 로직 적용 필요)
     * @param {*} context
     * act007_createFido -> $bridge.fidoCertn -> fidoCertn_callback -> act008_createFido
     */
    act007_createFido: function(context, payload) {
      Object.assign(context.state.fidoCertn, getDefaultState().fidoCertn);
      context.state.fidoCertn.uafRequest.in = payload.param;
      context.state.router = payload.router;
      context.state.route = payload.route;

      return new Promise(resolve => {
        this._vm.$post(
          "/commonbiz/auth/actionSimpleLoginForUafRequest",
          context.state.fidoCertn.uafRequest.in,
          response => {
            this._vm.$set(context.state.fidoCertn.uafRequest.out, "success", response);
            context.dispatch("act002_createFido", "fidoCertn");
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.fidoCertn.uafRequest.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 간편로그인 인증응답 및 로그인 - commonbiz에서 처리함(로그인 후 처리 로직 적용 필요)
     * @param {*} context
     */
    act008_createFido: function(context) {
      context.state.fidoCertn.uafResponse.in.fidoid = context.state.fidoCertn.uafRequest.in.fidoid;
      context.state.fidoCertn.uafResponse.in.bioType = context.state.fidoCertn.uafRequest.in.bioType;
      context.state.fidoCertn.uafResponse.in.uafResponse = context.state.fidoCertn.appReq.out.uafResponse;
      context.state.fidoCertn.uafResponse.in.smphMchtlUniqNo = this.state.native.smphMchtlUniqNo;
      context.state.fidoCertn.uafResponse.in.appTokenCtnt = this.state.native.smphMchtlUniqNo;
      context.state.fidoCertn.uafResponse.in.pshtCtnt = this.state.native.pushToken;
      context.state.fidoCertn.uafResponse.in.appVsnnoName = this.state.native.appVersionName;
      context.state.fidoCertn.uafResponse.in.oSzInfoCtnt = this.state.native.pgmVsnno;
      context.state.fidoCertn.uafResponse.in.smphMchtlDstcd = this.state.native.smphMchtlDstcd;

      return new Promise(resolve => {
        this._vm.$post(
          "/commonbiz/auth/actionSimpleLoginForUafResponse",
          context.state.fidoCertn.uafResponse.in,
          response => {
            this._vm.$set(context.state.fidoCertn.uafResponse.out, "success", response);
            resolve("success");
            context.dispatch("act009_createFido", response);
          },
          response => {
            this._vm.$set(context.state.fidoCertn.uafResponse.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 간편로그인 성공시.. 로그인 성공 후 처리
     * @param {*} context
     * @param {*} payload
     */
    act009_createFido: function(context, payload) {
      this.dispatch("actLoginSuccess", { response: payload, router: context.state.router, route: context.state.route, loginDscd: context.state.fidoCertn.uafResponse.in.bioType });
    },
    /**
     * fido 간편인증번호 오류누적 업데이트
     */
    act011_createFido: function(context) {
      return new Promise(resolve => {
        context.state.updatePincodeErr.in.fidoid = this.state.auth.createFido.fidoCertn.appReq.in.userName;

        this._vm.$post(
          "/auth/fido/certn/updatePincodeErr",
          context.state.updatePincodeErr.in,
          response => {
            this._vm.$set(context.state.updatePincodeErr.out, "success", response);
            this.state.simpleLogin.selectFidoInfo = response.fidoInfo;
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.updatePincodeErr.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * fido 정보를 조회 native - 로그인 후
     */
    act013_createFido: function() {
      this.state.auth.createFido.checkCreateFidoNative === false;
      this._vm.$bridge.fidoRegInfo();
      return new Promise(resolve => {
        checkingCreateFido = setInterval(() => {
          if (this.state.auth.createFido.checkCreateFidoNative === true) {
            clearInterval(checkingCreateFido);
            resolve("SUCCESS");
          }
        }, 5);
      });
    },
    /**
     * 기기와 fido원장에 유효한 발급데이터가 있는지 확인함. - 로그인 후 거래.
     * PINCODE는 정상인 경우만 true로..
     */
    act014_createFido: async function(context) {
      // 기기의 fido 등록정보를 가져옴.
      await this.dispatch("auth/createFido/act013_createFido");

      // 서버의 fido 등록정보를 가져옴.
      await this.dispatch("auth/createFido/act006_createFido");

      const fidoid = this.state.auth.createFido.svrFidoInfo.out.success.fidoid;
      const sp = this.state.auth.createFido.svrFidoInfo.out.success.fidoInfo.pinStusDstcd;
      const sf = this.state.auth.createFido.svrFidoInfo.out.success.fidoInfo.fngprRegiDstcd;
      const s1 = this.state.auth.createFido.svrFidoInfo.out.success.fidoInfo.smphMchtlUniqNo;
      const s2 = this.state.native.smphMchtlUniqNo;
      const arr = this.state.auth.createFido.fidoRegInfo.out;

      const fidoStatus = this._vm.$auth.getFidoStatus(fidoid, s1, s2, sp, sf, arr);
      // this._vm.$log.info("fidoStatus >>>> " + JSON.stringify(fidoStatus));

      if (fidoStatus.isPincode === "1") {
        context.state.isPincode = "1";
      } else {
        context.state.isPincode = "0";
      }

      if (fidoStatus.isFingerprint === "1") {
        context.state.isFingerprint = "1";
      } else {
        context.state.isFingerprint = "0";
      }

      return fidoStatus;
    },
    /**
     * fido 인증 - 일반인증
     * @param {*} context
     * @param {*} payload
     */
    act015_createFido: function(context, payload) {
      Object.assign(context.state.fidoCertn, getDefaultState().fidoCertn);
      context.state.fidoCertn.uafRequest.in = payload;

      return new Promise(resolve => {
        this._vm.$post(
          "/auth/fido/certn/UafCertnRequest",
          context.state.fidoCertn.uafRequest.in,
          response => {
            this._vm.$set(context.state.fidoCertn.uafRequest.out, "success", response);
            context.dispatch("act002_createFido", "fidoCertn_general");
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.fidoCertn.uafRequest.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * fido 인증 응답 - 일반인증
     */
    act017_createFido: function(context) {
      context.state.fidoCertn.uafResponse.in.fidoid = context.state.fidoCertn.uafRequest.in.fidoid;
      context.state.fidoCertn.uafResponse.in.bioType = context.state.fidoCertn.uafRequest.in.bioType;
      context.state.fidoCertn.uafResponse.in.uafResponse = context.state.fidoCertn.appReq.out.uafResponse;
      context.state.fidoCertn.uafResponse.in.bizDscd = context.state.fidoCertn.uafRequest.in.bizDscd;

      return new Promise(resolve => {
        this._vm.$post(
          "/auth/fido/certn/UafCertnResponse",
          context.state.fidoCertn.uafResponse.in,
          response => {
            this._vm.$set(context.state.fidoCertn.uafResponse.out, "success", response);

            if (context.state.fidoCertn.uafRequest.in.bizDscd === "createFingerprint") {
              // fido일반인증 완료 후 fido fingerprint 발급
              const param = {
                device: context.rootState.native.smphMchtlUniqNo,
                smphMdelName: context.rootState.native.smphMdelName,
                bioType: "FINGERPRINT",
              };
              // act004_createFido(fido 등록요청) -> brige -> act005_createFido(fido 등록완료함수)
              context.dispatch("act004_createFido", param);
            } else if (context.state.fidoCertn.uafRequest.in.bizDscd === "changePincode") {
              // fido일반인증 완료 후 pincode 등록
              // 첫번째 입력시.
              if (context.state.checkMpin.in.mPin01 === "" && context.state.checkMpin.in.mPin02 === "") {
                context.dispatch("act002_createFido", "openKeypadForFidoReg1");
              }

              // 두번째 입력시.
              if (context.state.checkMpin.in.mPin01 !== "" && context.state.checkMpin.in.mPin02 === "") {
                // bridge -> act001_createFido
                context.dispatch("act002_createFido", "openKeypadForFidoReg2");
              }
            } else if (context.state.fidoCertn.uafRequest.in.bizDscd === "regFingerprint") {
              // fido일반인증 완료 후 fido fingerprint 등록 완료
              const param = {
                device: context.rootState.native.smphMchtlUniqNo,
                smphMdelName: context.rootState.native.smphMdelName,
                bioType: "FINGERPRINT",
              };
              // // act005_createFido(fido 등록완료함수)
              context.dispatch("act005_createFido", param);
            }
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.fidoCertn.uafResponse.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
     * fido인증 에러처리 - 간편로그인 에러 콜백, fido일반인증 에러 콜백 ■■■■■■■■■■■■■■■■■■■■■■■■■■
     * ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
     */
    act018_createFido: function(context) {
      /* ios      PINCODE      : failcount 5 이상
							    FINGERPRINT  : 16(5회연속-잠김 시스템에서 풀어야함) 그라운드 OFF
		     android  PINCODE      : failcount 5 이상
						      FINGERPRINT  : 10(5회이상-잠김 시간지나면 풀림) 그라운드 OFF
	    */

      if (Number(context.state.fidoCertn.appReq.out.failcount) >= 5) {
        context.dispatch("act011_createFido");
      }

      // FidoActionSheetOpen 에서 처리
      if (context.state.fidoCertn.appReq.out.errorcode === "16" || context.state.fidoCertn.appReq.out.errorcode === "10") {
        this.state.auth.createFido.isFidoActionSheetError = true;
        if (context.state.fidoCertn.appReq.out.errorcode === "16") {
          this.state.auth.createFido.fidoActionSheetContent = "FIDO-0001";
        }
        if (context.state.fidoCertn.appReq.out.errorcode === "10") {
          this.state.auth.createFido.fidoActionSheetContent = "FIDO-0002";
        }
        this.state.auth.createFido.isFidoActionSheetOpen = true;
        return;
      }

      // FidoActionSheetOpen 유지
      if (
        context.state.fidoCertn.appReq.out.errorcode === "1" ||
        context.state.fidoCertn.appReq.out.errorcode === "2" ||
        context.state.fidoCertn.appReq.out.errorcode === "4" ||
        context.state.fidoCertn.appReq.out.errorcode === "11"
      ) {
        this.state.auth.createFido.isFidoActionSheetOpen = true;
        return;
      }

      // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
      // FidoActionSheetOpen, FidoMoal 없이 처리(사용자취소..), 100(핀번호 오류. 네이티브처리)
      // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
      if (context.state.fidoCertn.appReq.out.errorcode === "3" || context.state.fidoCertn.appReq.out.errorcode === "100") {
        this.state.auth.createFido.isFidoActionSheetOpen = false;
        return;
      }

      // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
      // FIDO 등록이후에 지문이 추가된 경우..(fido 알림 actionsheet 에서 처리)
      // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
      if (context.state.fidoCertn.appReq.out.errorcode === "200" || context.state.fidoCertn.appReq.out.errorcode === "50") {
        this.state.auth.manageFido.fidoActShtTitle = "MLGI-06-02-04-01"; // 인증 사용 안내
        this.state.auth.manageFido.isPositiveButton = true;
        this.state.auth.manageFido.fidoActShtConfirmText = "MLGI-06-02-03-03"; // 확인
        this.state.auth.manageFido.fidoActShtConfirmFunction = () => {
          this.state.auth.manageFido.isFidoActShtOpen = false;
        };

        // 로그인 되어 있는경우, 지문등록 버튼 노출함.
        if (this.getters.isLogin) {
          this.state.auth.manageFido.isNegativeButton = true;
          this.state.auth.manageFido.fidoActShtCancelText = "MLGI-05-01-05-04"; // 인증번호 재설정
          this.state.auth.manageFido.fidoActShtCancelFunction = () => {
            this.state.auth.manageFido.isFidoActShtOpen = false;
            // 바이오 등록 시작..
            this.state.simpleLogin.selectedLoginType === "FINGERPRINT";
            this.dispatch("auth/manageFido/act005_manageFido");
          };
          // 비로그인 인 경우(로그인화면), 확인버튼만 노출함.
        } else {
          this.state.auth.manageFido.isNegativeButton = false;
        }
        this.state.auth.manageFido.fidoActShtContents1 = "FIDO-0004"; // 인증 정보가 변경되었습니다.
        this.state.auth.manageFido.fidoActShtContents2 = "FIDO-0005"; // 기존에 등록하신 생체 인증 정보와 현재 단말기에 정보가 일치하지 않습니다.
        this.state.auth.manageFido.fidoActShtContents3 = "FIDO-0006"; // 단말기에 지문 또는 Face ID 설정을 변경하신 경우 반드시 로그인 인증 업데이트가 필요합니다.

        this.state.auth.createFido.isFidoActionSheetOpen = false;
        this.state.auth.manageFido.isFidoActShtOpen = true;

        return;
      }

      // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
      // 인증타임오버.. (fido 알림 actionsheet 에서 처리)
      // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
      if (context.state.fidoCertn.appReq.out.errorcode === "14") {
        this.state.auth.manageFido.fidoActShtTitle = "MLGI-06-02-04-01"; // 인증 사용 안내
        this.state.auth.manageFido.isPositiveButton = true;
        this.state.auth.manageFido.isNegativeButton = false;
        this.state.auth.manageFido.fidoActShtConfirmText = "MLGI-06-02-03-03"; // 확인
        this.state.auth.manageFido.fidoActShtConfirmFunction = () => {
          this.state.auth.manageFido.isFidoActShtOpen = false;
        };
        this.state.auth.manageFido.fidoActShtContents1 = "FIDO-0007"; // 인증 시간이 초과되었습니다.
        this.state.auth.manageFido.fidoActShtContents2 = "FIDO-0008"; // 지문 또는 Face ID 인증을 위해 대기하는 시간이 초과되어 인증 실패하였습니다.

        this.state.auth.createFido.isFidoActionSheetOpen = false;
        this.state.auth.manageFido.isFidoActShtOpen = true;

        return;
      }

      // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
      // 생체인증 권한이 없는 경우.. (fido 알림 actionsheet 에서 처리)
      // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
      if (context.state.fidoCertn.appReq.out.errorcode === "51") {
        this.state.auth.manageFido.fidoActShtTitle = "MLGI-06-02-04-01"; // 인증 사용 안내
        this.state.auth.manageFido.isPositiveButton = true;
        this.state.auth.manageFido.fidoActShtConfirmText = "MLGI-06-02-03-03"; // 확인
        this.state.auth.manageFido.fidoActShtConfirmFunction = () => {
          this.state.auth.manageFido.isFidoActShtOpen = false;
        };
        this.state.auth.manageFido.fidoActShtContents1 = "FIDO-0010"; // 생체 인증 권한이 없습니다.
        this.state.auth.manageFido.fidoActShtContents2 = "FIDO-0011"; // 지문 또는 Face ID를 사용하기 위해서는 휴대폰에 사용 권한을 허용해 주셔야 합니다.
        this.state.auth.manageFido.fidoActShtContents3 = "FIDO-0013"; // iOS > Settings > Face ID & Passcode > Other Apps > KB Global Banking > Face ID 설정을 “허용”으로 변경.
        this.state.auth.manageFido.isNegativeButton = false;

        this.state.auth.createFido.isFidoActionSheetOpen = false;
        this.state.auth.manageFido.isFidoActShtOpen = true;

        return;
      }

      // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
      // 기타 인증실패처리
      // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
      this.state.auth.createFido.isFidoActionSheetOpen = false;

      // FidoMoal 처리
      this.state.error.active = true;
      this.state.error.errCode = context.state.fidoCertn.appReq.out.errorcode;

      // this.state.lang
      if (this.state.lang === "KOR") {
        this.state.error.errMsg = "인증 실패";
      } else if (this.state.lang === "MMR") {
        this.state.error.errMsg = "verification failed";
      } else if (this.state.lang === "KHM") {
        this.state.error.errMsg = "ការផ្ទៀងផ្ទាត់បរាជ័យ";
      } else if (this.state.lang === "VNM") {
        this.state.error.errMsg = "Xác minh thất bại";
      } else {
        this.state.error.errMsg = "verification failed";
      }
    },
    /**
     * ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
     * fido등록 에러처리 - 간편로그인 등록 에러 콜백 ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
     * ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
     */
    act019_createFido: function(context) {
      // FidoActionSheetOpen 에서 처리
      if (context.state.fidoReg.appReq.out.errorcode === "16" || context.state.fidoReg.appReq.out.errorcode === "10") {
        this.state.auth.createFido.isFidoActionSheetError = true;
        if (context.state.fidoReg.appReq.out.errorcode === "16") {
          this.state.auth.createFido.fidoActionSheetContent = "FIDO-0001";
        }
        if (context.state.fidoReg.appReq.out.errorcode === "10") {
          this.state.auth.createFido.fidoActionSheetContent = "FIDO-0002";
        }
        this.state.auth.createFido.isFidoActionSheetOpen = true;
        return;
      }

      // FidoActionSheetOpen 유지
      if (
        context.state.fidoReg.appReq.out.errorcode === "1" ||
        context.state.fidoReg.appReq.out.errorcode === "2" ||
        context.state.fidoReg.appReq.out.errorcode === "4" ||
        context.state.fidoReg.appReq.out.errorcode === "11"
      ) {
        this.state.auth.createFido.isFidoActionSheetOpen = true;
        return;
      }

      // FidoActionSheetOpen, FidoMoal 없이 처리(사용자취소..)
      if (context.state.fidoReg.appReq.out.errorcode === "3") {
        this.state.auth.createFido.isFidoActionSheetOpen = false;
        return;
      }

      this.state.auth.createFido.isFidoActionSheetOpen = false;

      // FidoMoal 처리
      this.state.error.active = true;
      this.state.error.errCode = context.state.fidoReg.appReq.out.errorcode;

      // this.state.lang
      if (this.state.lang === "KOR") {
        this.state.error.errMsg = "등록 실패";
      } else {
        this.state.error.errMsg = "Registration Failed";
      }
    },
    /**
     * 지문간편이체 사용여부를 저장함.
     */
    act020_createFido: function(context, payload) {
      return new Promise(resolve => {
        this._vm.$post(
          "/auth/fido/fidoIssunc/updateFidoInfo",
          { fngprUseYn: payload },
          response => {
            this._vm.$set(context.state.svrFidoInfo.out, "success", response);
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.svrFidoInfo.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 간편로그인 인증요청 - commonbiz에서 처리함(로그인 후 처리 로직 적용 필요)
     * - 간편로그인 안내(createFidoPincodeGuide)에서 간편로그인 후 fido 등록 프로세스
     * @param {*} context
     * act021_createFido(간편인증번호 로그인) -> $bridge.fidoCertn_fidoReg(native 간편인증번호 로그인)
     *   -> fidoCertn_callback_fidoReg(native return 처리) -> act023_createFido(로그인) & FIDO 등록
     */
    act021_createFido: function(context, payload) {
      Object.assign(context.state.fidoCertn, getDefaultState().fidoCertn);
      context.state.fidoCertn.uafRequest.in = payload.param;
      context.state.router = payload.router;
      context.state.route = payload.route;

      return new Promise(resolve => {
        this._vm.$post(
          "/commonbiz/auth/actionSimpleLoginForUafRequest",
          context.state.fidoCertn.uafRequest.in,
          response => {
            this._vm.$set(context.state.fidoCertn.uafRequest.out, "success", response);
            context.dispatch("act002_createFido", "fidoReg_simpleLogin");
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.fidoCertn.uafRequest.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 간편로그인 인증응답 및 로그인 - commonbiz에서 처리함(로그인 후 처리 로직 적용 필요)
     * @param {*} context
     */
    act022_createFido: function(context) {
      context.state.fidoCertn.uafResponse.in.fidoid = context.state.fidoCertn.uafRequest.in.fidoid;
      context.state.fidoCertn.uafResponse.in.bioType = context.state.fidoCertn.uafRequest.in.bioType;
      context.state.fidoCertn.uafResponse.in.uafResponse = context.state.fidoCertn.appReq.out.uafResponse;
      context.state.fidoCertn.uafResponse.in.smphMchtlUniqNo = this.state.native.smphMchtlUniqNo;
      context.state.fidoCertn.uafResponse.in.appTokenCtnt = this.state.native.smphMchtlUniqNo;
      context.state.fidoCertn.uafResponse.in.pshtCtnt = this.state.native.pushToken;
      context.state.fidoCertn.uafResponse.in.appVsnnoName = this.state.native.appVersionName;
      context.state.fidoCertn.uafResponse.in.oSzInfoCtnt = this.state.native.pgmVsnno;
      context.state.fidoCertn.uafResponse.in.smphMchtlDstcd = this.state.native.smphMchtlDstcd;

      return new Promise(resolve => {
        this._vm.$post(
          "/commonbiz/auth/actionSimpleLoginForUafResponse",
          context.state.fidoCertn.uafResponse.in,
          response => {
            this._vm.$set(context.state.fidoCertn.uafResponse.out, "success", response);
            resolve("success");
            context.dispatch("act023_createFido", response);
          },
          response => {
            this._vm.$set(context.state.fidoCertn.uafResponse.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
    /**
     * 간편로그인 성공시.. 로그인 성공 후 fido 등록을 위한 native call
     * @param {*} context
     * @param {*} payload
     */
    act023_createFido: function(context, payload) {
      this.dispatch("actLoginSuccess", { response: payload, router: context.state.router, route: context.state.route, loginDscd: context.state.fidoCertn.uafResponse.in.bioType });

      // 간편인증번호 로그인 완료 후 fido fingerprint 발급
      const param = {
        device: context.rootState.native.smphMchtlUniqNo,
        smphMdelName: context.rootState.native.smphMdelName,
        bioType: "FINGERPRINT",
        bizDscd: "regFingerprint",
      };
      // act024_createFido(fido 등록요청) -> bridge
      // -> act025_createFido(간편인증요청) -> bridge -> act005_createFido(FIDO 등록응답)
      context.dispatch("act024_createFido", param);
    },
    /**
     * FIDO 등록요청
     * @param {*} context
     */
    act024_createFido: function(context, payload) {
      Object.assign(context.state.fidoReg, getDefaultState().fidoReg);
      context.state.fidoReg.uafRequest.in = payload;

      return new Promise(resolve => {
        this._vm.$post(
          "/auth/fido/fidoIssunc/uafRegRequest",
          context.state.fidoReg.uafRequest.in,
          response => {
            this._vm.$set(context.state.fidoReg.uafRequest.out, "success", response);
            context.dispatch("act002_createFido", "fidoReg_fidoReq");
            resolve("success");
          },
          response => {
            this._vm.$set(context.state.fidoReg.uafRequest.out, "fail", response);
            resolve("fail");
          },
        );
      });
    },
  },
};

export default createFido;
